import { render } from "./termSeqBoxInfo.vue?vue&type=template&id=1b38af51"
import script from "./termSeqBoxInfo.vue?vue&type=script&lang=js"
export * from "./termSeqBoxInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__